"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var HelperModal = /*#__PURE__*/function (_window$AbstractBoots) {
    _inherits(HelperModal, _window$AbstractBoots);

    var _super = _createSuper(HelperModal);

    _createClass(HelperModal, null, [{
      key: "CLASSNAME",
      get: function get() {
        return "helper-modal";
      }
    }]);

    function HelperModal() {
      _classCallCheck(this, HelperModal);

      return _super.call(this, "helper-modal", {
        $domElement: $("#helper-modal")
      });
    }

    _createClass(HelperModal, [{
      key: "init",
      value: function init() {
        var _self = this;

        $(window).off(window.HelperModal.CLASSNAME + ".show").on(window.HelperModal.CLASSNAME + ".show", function (event, data) {
          data ? _self.show(data) : _self.show();
        });
        $(window).off(window.HelperModal.CLASSNAME + ".hide").on(window.HelperModal.CLASSNAME + ".hide", this.hide.bind(this));

        _get(_getPrototypeOf(HelperModal.prototype), "init", this).call(this);
      }
    }, {
      key: "update",
      value: function update() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.$domElement.attr("data-theme", data.theme ? data.theme : "");

        if (data && data.header && data.theme) {
          switch (data.theme) {
            case window.AbstractBootstrapModal.THEME_DANGER:
              data.header = "<div><i class=\"fa fa-bell\" aria-hidden=\"true\"></i>" + data.header + "</div>";
              break;

            case window.AbstractBootstrapModal.THEME_WARNING:
              data.header = "<div><i class=\"fa fa-bell\" aria-hidden=\"true\"></i>" + data.header + "</div>";
              break;

            case window.AbstractBootstrapModal.THEME_SUCCESS:
              data.header = "<div><i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>" + data.header + "</div>";
              break;

            default:
              data.header = "<div>" + data.header + "</div>";
              break;
          }
        }

        if (data && data.closeBtn) {
          if (data.header) data.header += "<button type=\"button\" class=\"btn btn-close\" data-dismiss=\"modal\"></button>";else data.header = "<button type=\"button\" class=\"btn btn-close\" data-dismiss=\"modal\"></button>";
        }

        _get(_getPrototypeOf(HelperModal.prototype), "update", this).call(this, data);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        $(window).off(window.HelperModal.CLASSNAME + ".show");
        $(window).off(window.HelperModal.CLASSNAME + ".hide");

        _get(_getPrototypeOf(HelperModal.prototype), "dispose", this).call(this);
      }
    }]);

    return HelperModal;
  }(window.AbstractBootstrapModal);

  window.HelperModal = HelperModal;
})(window);
